import styled from 'styled-components';
import { toRem, baseVariables, contextualVariable } from '@marriott/mi-ui-library';

export const StyledSignInDrawer = styled.div`
  [role='dialog'] {
    height: 100vh;
    overflow-y: scroll;
  }
`;

export const StyledSignInButton = styled.button<{ isBrandedVariation: boolean; isAuthenticated: boolean }>`
  align-items: center;
  background: transparent;
  display: flex;
  padding: 0;
  color: inherit;

  &.color-scheme7 {
    .utility-icon {
      &::before {
        color: inherit !important;
      }
    }
  }

  &:focus {
    outline: 1px dotted #212121 !important;
    outline: 5px auto -webkit-focus-ring-color !important;
  }

  @media ${({ isBrandedVariation }) =>
      isBrandedVariation ? baseVariables.mediaQuery.md : baseVariables.mediaQuery.lg} {
    padding: ${toRem(8)} ${toRem(16)};
    border: ${({ isAuthenticated }) => `${toRem(1)} solid ${isAuthenticated ? 'transparent' : 'currentColor'}`};
    border-radius: ${toRem(20)};
    margin: 0;

    &.unauthenticated:hover,
    .standard &.unauthenticated:hover,
    .header-sticky &.unauthenticated:hover,
    .brand-css &.unauthenticated:hover {
      background: ${({ isBrandedVariation }) =>
        isBrandedVariation ? contextualVariable.buttonSecondaryHoverBgColor : baseVariables.color['base10']};
      color: ${({ isBrandedVariation }) =>
        isBrandedVariation ? contextualVariable.buttonSecondaryHoverTxtColor : 'white'};
      * {
        color: inherit;
      }
    }
  }

  &.rememberedBtn {
    @media ${baseVariables.mediaQuery.xl} {
      border: none;
    }
  }

  .standard &,
  .header-sticky &,
  .brand-css & {
    color: ${({ isBrandedVariation }) =>
      isBrandedVariation ? contextualVariable.brandFgColor : baseVariables.color['base10']};

    @media ${({ isBrandedVariation }) =>
        isBrandedVariation ? baseVariables.mediaQuery.md : baseVariables.mediaQuery.lg} {
      border-color: ${({ isBrandedVariation, isAuthenticated }) =>
        isBrandedVariation
          ? isAuthenticated
            ? 'transparent'
            : contextualVariable.buttonSecondaryBorderColor
          : baseVariables.color['base10']};

      color: ${({ isBrandedVariation, isAuthenticated }) =>
        isBrandedVariation
          ? isAuthenticated
            ? contextualVariable.brandFgColor
            : contextualVariable.buttonSecondaryTxtColor
          : baseVariables.color['base10']};
    }
  }

  .icon-arrow-right {
    margin-left: ${toRem(4)};
  }
`;

export const AccountDrawer = styled.div<{ isOpen: boolean }>`
  position: fixed;
  left: 0;
  width: 100vw;
  z-index: ${({ isOpen }) => (isOpen ? `999` : `-1`)};
  background: ${({ isOpen }) => (isOpen ? `rgba(28, 28, 28, 0.56)` : `rgba(28, 28, 28, 0)`)};
  transition: background-color 0.3s;
`;
